export const PAYMENT_HOBEX = 'hobex';
export const PAYMENT_SEPA = 'sepa';
export const PAYMENT_PAYMENT_SLIP = 'erlagschein';

export const PAYMENT_TYPE_ANNUAL = 1;
export const PAYMENT_TYPE_BIANNUAL = 2;
export const PAYMENT_TYPE_QUARTERLY = 4;
export const PAYMENT_TYPE_MONTHLY = 12;
